import React from "react";

const Settings = () => {
  return (
    <div className="settings-container">
      <h1>Admin Settings</h1>
      <p>Configure website settings and preferences here.</p>
    </div>
  );
};

export default Settings;
